export default "__VITE_ASSET__CgWqS$sz__"